var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import cls from "classnames";
import lodash from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { RicosContext } from "./../../../ricos-context";
import { LoaderIcon } from "../../assets/icons/LoaderIcon";
import { RCEHelpersPropTypes, withRCEHelpers } from "../rce-helpers-context";
import styles from "./text-field-scss";
class TextFieldComponent extends React.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "$el", React.createRef());
    __publicField(this, "state", {
      placeholder: this.props.placeholder,
      rows: 1,
      syncing: false,
      isFocused: false
    });
    __publicField(this, "handleWindowResizeEvent", () => setTimeout(() => this.resize()));
    __publicField(this, "handleFocus", (e) => {
      e.stopPropagation();
      setTimeout(() => this.resize());
      this.hidePlaceholder();
      this.props.rce.setInPluginEditingMode(true);
      this.setState({ isFocused: true });
    });
    __publicField(this, "handleBlur", () => {
      setTimeout(() => this.resize());
      this.showPlaceholder();
      this.props.rce.setInPluginEditingMode(false);
      this.setState({ isFocused: false });
    });
    __publicField(this, "handleChange", (event) => {
      this.props.onChange(event.target.value);
      this.resize();
    });
  }
  componentDidMount() {
    const { rce } = this.props;
    const isEditMode = !rce.isViewMode;
    if (isEditMode) {
      this.resize();
    }
    this.handleAutoFocus();
    window?.addEventListener("resize", this.handleWindowResizeEvent);
  }
  componentDidUpdate(props) {
    if (this.props.rce.isViewMode === props.rce.isViewMode) {
      return;
    }
    this.handleAutoFocus();
  }
  handleAutoFocus() {
    const { rce, autofocus } = this.props;
    const isEditMode = !rce.isViewMode;
    if (autofocus && isEditMode) {
      this.$el.current?.focus();
    }
  }
  componentWillUnmount() {
    window?.removeEventListener("resize", this.handleWindowResizeEvent);
  }
  hidePlaceholder() {
    this.setState({ placeholder: "" });
  }
  showPlaceholder() {
    this.setState({ placeholder: this.props.placeholder });
  }
  handleKeyDown(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  }
  resize() {
    const { jsdomMode } = this.context;
    if (!this.$el.current || jsdomMode) {
      return;
    }
    const computedStyles = getComputedStyle(this.$el.current);
    const lineHeight = parseInt(computedStyles.lineHeight);
    const paddingTop = parseInt(computedStyles.paddingTop);
    const paddingBottom = parseInt(computedStyles.paddingBottom);
    this.$el.current.rows = 1;
    const { scrollHeight } = this.$el.current;
    this.$el.current.rows = this.state.rows;
    const contentHeight = scrollHeight - (paddingTop + paddingBottom);
    const rows = Math.ceil(lodash.clamp(contentHeight / lineHeight, 1, Infinity));
    this.setState({ rows });
  }
  render() {
    const {
      dataHook,
      textAutoResize,
      className,
      rce,
      endAdornment,
      style,
      children,
      startAdornment,
      maxLength,
      disabled,
      value
    } = this.props;
    const { placeholder, rows, syncing, isFocused } = this.state;
    if (rce.isViewMode || rce.isPreview) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        "p",
        {
          style,
          className: cls(
            styles.text,
            className,
            textAutoResize && {
              [styles.small]: value.length > 120,
              [styles.medium]: value.length <= 120,
              [styles.large]: value.length <= 80
            },
            {
              [styles.webview]: rce.isWebView
            }
          )
        },
        startAdornment,
        children,
        /* @__PURE__ */ React.createElement("span", { className: styles.value, "data-hook": dataHook }, this.props.value || this.props.placeholder)
      ));
    }
    return /* @__PURE__ */ React.createElement("div", { className: styles.root }, startAdornment, /* @__PURE__ */ React.createElement(
      "textarea",
      {
        "data-hook": dataHook,
        disabled,
        maxLength,
        style,
        ref: this.$el,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        placeholder,
        value,
        rows,
        onKeyDown: this.handleKeyDown,
        className: cls(
          styles.input,
          className,
          textAutoResize && {
            [styles.small]: value.length > 120,
            [styles.medium]: value.length <= 120,
            [styles.large]: value.length <= 80
          }
        ),
        onClick: void 0
      }
    ), /* @__PURE__ */ React.createElement(
      "span",
      {
        className: cls(styles.endAdornment, {
          [styles.shown]: syncing || isFocused
        })
      },
      syncing ? /* @__PURE__ */ React.createElement(LoaderIcon, { className: styles.spinner }) : endAdornment
    ));
  }
}
__publicField(TextFieldComponent, "contextType", RicosContext);
const TextField = withRCEHelpers(TextFieldComponent);
TextFieldComponent.defaultProps = {
  maxLength: 500,
  disabled: false
};
TextFieldComponent.propTypes = {
  dataHook: PropTypes.string,
  autofocus: PropTypes.bool,
  maxLength: PropTypes.number,
  value: PropTypes.string,
  disabled: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  textAutoResize: PropTypes.bool,
  startAdornment: PropTypes.node,
  endAdornment: PropTypes.node,
  ...RCEHelpersPropTypes
};
export {
  TextField
};
//# sourceMappingURL=TextField.js.map
